// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"d341db39","340":"51501680","737":"ac426af1"}[chunkId] + ".chunk.js";
};